export default __webpack_public_path__ + "assets/images/6f5d58f6a54dcb41085bd9b57d164ab7.svg";